import { forwardRef } from "react";
import { app } from "src/core/app";
import { IconText } from ".";

export const BackButton = forwardRef<HTMLAnchorElement, { label: string, href: string }>((props, ref) => {
    return (
        <a ref={ref} className="eac-back-button" href={props.href} onClick={navigateBack}>
            <IconText icon="arrowLeft">{props.label}</IconText>
        </a>
    );

    function navigateBack(e: React.UIEvent) {
        if (props.href === app.previousPath) {
            app.back();
            e.preventDefault();
        }
    }
});
